export default {
  "company-page": () => import("/home/runner/work/onboard/onboard/Code/app/src/layouts/company-page.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/onboard/onboard/Code/app/src/layouts/default.vue").then(m => m.default || m),
  "landing-page": () => import("/home/runner/work/onboard/onboard/Code/app/src/layouts/landing-page.vue").then(m => m.default || m),
  "terms-page": () => import("/home/runner/work/onboard/onboard/Code/app/src/layouts/terms-page.vue").then(m => m.default || m)
}